import React from 'react'

const PublicTab = () => {
  return (
    <div className='publicTab-sec form-tabs-comon'>
        <form>
            <div className="form-group d-flex  flex-md-nowrap flex-wrap  align-items-center">
                <label for="" className="col-form-label">Event</label>
                <div className="form-box">
                    {/* <input type="text" className="form-control" id=""/> */}
                    <select name="" id="">
                      <option value="">Select</option>
                      <option value="">Select 1</option>
                      <option value="">Select 2</option>
                    </select>
                </div>
            </div>
            <div className="form-group d-flex  flex-md-nowrap flex-wrap  align-items-center">
                <label for="" className="col-form-label">State</label>
                <div className="form-box">
                    <select name="" id="">
                      <option value="">Select</option>
                      <option value="">MP</option>
                      <option value="">UP</option>
                      <option value="">MH</option>
                      <option value="">CG</option>
                    </select>
                </div>
            </div>
            <div className="form-group input-full-box d-flex  flex-md-nowrap flex-wrap  align-items-center">
                <label for="" className="col-form-label">Address </label>
                <div className="form-box">
                    <input type="text" className="form-control" id="" placeholder="Start Typing" />
                </div>
            </div>
            <div className="form-group d-flex  flex-md-nowrap flex-wrap  align-items-center">
                <label for="" className="col-form-label">Service</label>
                <div className="form-box">
                    <select name="" id="">
                      <option value="">Select</option>
                      <option value="">Service 1</option>
                      <option value="">Service 2</option>
                      <option value="">Service 3</option>
                      <option value="">Service 4</option>
                    </select>
                </div>
            </div>
            <div className="form-group d-flex  flex-md-nowrap flex-wrap  align-items-center">
                <label for="" className="col-form-label">Date </label>
                <div className="form-box">
                    <input type="text" className="form-control" id="" placeholder="00/00/00" />
                </div>
            </div>
            <div className="form-group d-flex  flex-md-nowrap flex-wrap  align-items-center">
               <div className='form-group-fixed d-flex  flex-md-nowrap flex-wrap  align-items-center'>
                  <label for="" className="col-form-label">Time </label>
                  <div className="form-box">
                      <input type="text" className="form-control" id="" placeholder="00:00" />
                  </div>
               </div>
               <div className='form-group-fixed d-flex flex-md-nowrap flex-wrap align-items-center'>
                  <label for="" className="col-form-label">To </label>
                  <div className="form-box">
                      <input type="text" className="form-control" id="" placeholder="00:00" />
                  </div>
                  <span className='fixed-time'>0.0h</span>
               </div>
            </div>
            <div className="form-group d-flex  flex-md-nowrap flex-wrap  align-items-center">
                <label for="" className="col-form-label">Hourly Rate </label>
                <div className="form-box">
                    <input type="text" className="form-control" id="" placeholder="$0.00" />
                </div>
            </div>
            <div className="form-group d-flex form-allowance flex-md-nowrap flex-wrap align-items-center">
                <label for="" className="col-form-label">Travel Allowance</label>
                <div className="form-box">
                    <select name="" id="">
                      <option value="">Select</option>
                      <option value="">Allowance 1</option>
                      <option value="">Allowance 2</option>
                      <option value="">Allowance 3</option>
                      <option value="">Allowance 4</option>
                    </select>
                </div>
            </div>
            <div className="form-group d-flex flex-wrap align-items-center">
                <label for="" className="col-form-label d-none">Description </label>
                <div className="form-box">
                    <textarea name="" rows="5" cols="40" id="" placeholder='Description'></textarea>
                </div>
            </div>
            <button type='button' className='btn btn-border d-flex justify-content-center align-items-center m-auto'>Post</button>
        </form>
    </div>
  )
}

export default PublicTab
